import { useQuery, useQueryClient } from "@tanstack/react-query";
import { z as zod } from "zod";
import { fetchApiGet, fetchApiPost } from "./utils";
import { Trader, TraderCustomer } from "./reports";

export interface BaseTrader  {
    id: string;
    initials: string;
    name: string;
    is_trader: boolean;
    is_current_user: boolean;
}

export const CreateTraderValidation = zod.object({
  initials: zod.string().min(2).trim(),
  name: zod.string().min(2).trim(),
});

export const AssignTraderCustomerValidation = zod.object({
  trader_id: zod.string().uuid(),
  customer_id: zod.string().uuid(),
});


export function useListTraders() {
  const queryParams = new URLSearchParams();

  return useQuery({
    queryKey: ["baseTraders"],
    queryFn: () => fetchApiGet<Trader[]>("trader", queryParams),
    retry: 1,
  });
}

export const traderCustomerPairsQueryKey = ["baseTraderCustomerPairs"] as const;

export function useListTradersCustomerPairs() {
  const queryParams = new URLSearchParams();

  return useQuery({
    queryKey: traderCustomerPairsQueryKey,
    queryFn: () => fetchApiGet<TraderCustomer[]>("trader/customer/pairs", queryParams),
    retry: 1,
  });
}

export function useListBaseTraders() {
  const queryParams = new URLSearchParams();
  queryParams.set("is_trader", "true");

  return useQuery({
    queryKey: ["manage", "baseTraders"],
    queryFn: () => fetchApiGet<BaseTrader[]>("manage/traders", queryParams),
    retry: 1,
  });
}

export function useCreateTrader() {
  const queryClient = useQueryClient();
  const queryParams = new URLSearchParams();

  return async (data: typeof CreateTraderValidation._type) => {
    const result = await fetchApiPost<Trader>(
      "trader",
      data,
      queryParams,
    );

    queryClient.invalidateQueries({ queryKey: ["baseTraders"] });
    return result;
  };
}

